export default __webpack_public_path__ + "static/media/Scarlet Spellwarders Ring.936b073d.jpg";